<div class="modal-header">
  <h4 class="modal-title pull-left">
    {{ title | translate }}
  </h4>
  <button type="button" class="close pull-right" aria-label="Close modal" (click)="cancelAndClose()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  @if (error(); as error) {
    <nk-error-alert [error]="error"></nk-error-alert>
  }
  @if (!isLoading()) {
    <nk-add-to-screening-form
      [entityMonitoringTypeUuid]="entityMonitoringTypeUuid"
      (valueChanged)="onValueChanged($event)"
      (formValidityChanged)="onFormValidityChanged($event)"></nk-add-to-screening-form>
  } @else {
    <nk-progress></nk-progress>
  }
</div>

<div class="modal-footer">
  <button nkButton color="primary" [ghost]="true" (click)="cancelAndClose()">
    {{ 'common.cancel' | translate }}
  </button>
  <button nkButton color="secondary" [disabled]="!isFormValid() || isLoading()" (click)="addAndClose()">
    {{ 'common.ok' | translate }} <nk-spinner display="inline" [hidden]="!isLoading()"></nk-spinner>
  </button>
</div>
